import { render, staticRenderFns } from "./TextareaEmoji.vue?vue&type=template&id=85e42a1c&"
import script from "./TextareaEmoji.vue?vue&type=script&lang=js&"
export * from "./TextareaEmoji.vue?vue&type=script&lang=js&"
import style0 from "./TextareaEmoji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports